module.exports = __webpack_public_path__ + "static/meshImplant-457f0cd1ed1212bd08ae6ce0b9fd07cf.jpg";